'use strict';

var titles = require('../../../../../../../../../_virtual/titles.cjs');
require('../typography.cjs');
var typography$1 = require('../../../../../../../../../_virtual/typography.cjs');

var typography = typography$1.__exports;

const ChromaticTitleSize = typography.TYPOGRAPHY_TYPES.h2;

titles.__exports.ChromaticTitleSize = ChromaticTitleSize;

module.exports = titles.__exports;
//# sourceMappingURL=titles.cjs.map
